// extracted by mini-css-extract-plugin
export default {"header":"index_header__VyxKo","container":"index_container__BBWlr","drugHeader":"index_drugHeader__qOb1D"};